import addEvents$ from './addEvents'
import fetch$ from './fetchRoom'
import addRemoteParticipants$ from './addRemoteParticipants'
import addLocalEvents$ from './addLocalEvents'
import addLocalTracks$ from './addLocalTracks'
import checkVideoQuality$ from './checkVideoQuality'
import checkAudioAndVideoState$ from './checkAudioAndVideoState'
import addParticipantInformation$ from './addParticipantInformation'
import addMissingParticipantInformation$ from './addMissingParticipantInformation'
import checkPresenterDisconnected$ from './checkPresenterDisconnected'
import { combineEpics } from 'redux-observable'

export {
  addEvents$,
  fetch$,
  addRemoteParticipants$,
  addLocalEvents$,
  addLocalTracks$,
  checkVideoQuality$,
  checkAudioAndVideoState$,
  addParticipantInformation$,
  addMissingParticipantInformation$,
  checkPresenterDisconnected$
}

export default combineEpics(
  addEvents$,
  fetch$,
  addRemoteParticipants$,
  addLocalEvents$,
  addLocalTracks$,
  checkVideoQuality$,
  checkAudioAndVideoState$,
  addParticipantInformation$,
  addMissingParticipantInformation$,
  checkPresenterDisconnected$
)
